import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faWhatsapp, faFacebookMessenger, faTwitter } from "@fortawesome/free-brands-svg-icons";
import {faTimes} from '@fortawesome/free-solid-svg-icons';

Vue.component('font-awesome-icon', FontAwesomeIcon);

library.add(faWhatsapp, faFacebookMessenger, faTwitter, faTimes);